module.exports = __webpack_public_path__ + "img/snowyi.52d910fa.png";